(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "68700b6e42e0c53376042f73";
              window.beaePageSetting.pageTitle = "TIMER"; 
              window.beaePageSetting.pageType = "section";

          let js_51E7ID1T = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-f55o8gzusection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-f55o8gzu',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-f55o8gzu');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-f55o8gzu: ', ex)
      };
    

      try {
        let argid = 'beae-y80ifxy6block-countdown',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-y80ifxy6',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-y80ifxy6');
        args.el = args.els[0];
        ((w) => { w.mode.value=="builder"&&window.BeaeRunCountdown&&window.BeaeRunCountdown(w) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-y80ifxy6: ', ex)
      };
    }; if (window.BEAEBASE) {js_51E7ID1T()} else {window.BEAEPAGEJS.push(js_51E7ID1T)} })(); 